import React from 'react';
import { DumbbellIcon, ClockIcon, TargetIcon, FlameIcon, TrophyIcon, ClipboardListIcon } from 'lucide-react';
export function ForWho() {
  return <section id="para-quien" className="w-full bg-[#111111] py-20 px-4 sm:px-6 lg:px-8" data-id="element-83">
      <div className="max-w-7xl mx-auto" data-id="element-84">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-85">
          <h2 className="font-heading font-bold text-white uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight mb-4" data-id="element-86">
            Si te identificas con esto,
            <br className="hidden sm:block" data-id="element-87" /> esta es tu casa
          </h2>
          <div className="section-divider" data-id="element-88" />
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-89">
          {/* Card 1 */}
          <div className="bg-[#1a1a1a] border border-[#2a2a2a] border-l-4 border-l-[#C9A84C] p-6 group hover:bg-[#1f1f1f] transition-colors duration-200" data-id="element-90">
            <div className="flex items-start gap-4" data-id="element-91">
              <div className="flex-shrink-0 w-10 h-10 bg-[#C9A84C]/10 rounded flex items-center justify-center" data-id="element-92">
                <DumbbellIcon size={20} className="text-[#C9A84C]" data-id="element-93" />
              </div>
              <p className="font-body text-gray-300 text-sm sm:text-base leading-relaxed pt-1" data-id="element-94">
                Quieres ponerte en forma y te aburren los gimnasios normales
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-[#1a1a1a] border border-[#2a2a2a] border-l-4 border-l-[#C9A84C] p-6 group hover:bg-[#1f1f1f] transition-colors duration-200" data-id="element-95">
            <div className="flex items-start gap-4" data-id="element-96">
              <div className="flex-shrink-0 w-10 h-10 bg-[#C9A84C]/10 rounded flex items-center justify-center" data-id="element-97">
                <ClockIcon size={20} className="text-[#C9A84C]" data-id="element-98" />
              </div>
              <p className="font-body text-gray-300 text-sm sm:text-base leading-relaxed pt-1" data-id="element-99">
                Te falta disciplina y una rutina que te obligue a cumplir
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-[#1a1a1a] border border-[#2a2a2a] border-l-4 border-l-[#C9A84C] p-6 group hover:bg-[#1f1f1f] transition-colors duration-200" data-id="element-100">
            <div className="flex items-start gap-4" data-id="element-101">
              <div className="flex-shrink-0 w-10 h-10 bg-[#C9A84C]/10 rounded flex items-center justify-center" data-id="element-102">
                <TargetIcon size={20} className="text-[#C9A84C]" data-id="element-103" />
              </div>
              <p className="font-body text-gray-300 text-sm sm:text-base leading-relaxed pt-1" data-id="element-104">
                Quieres aprender a pegar y moverte con técnica de verdad
              </p>
            </div>
          </div>

          {/* Card 4 */}
          <div className="bg-[#1a1a1a] border border-[#2a2a2a] border-l-4 border-l-[#C9A84C] p-6 group hover:bg-[#1f1f1f] transition-colors duration-200" data-id="element-105">
            <div className="flex items-start gap-4" data-id="element-106">
              <div className="flex-shrink-0 w-10 h-10 bg-[#C9A84C]/10 rounded flex items-center justify-center" data-id="element-107">
                <FlameIcon size={20} className="text-[#C9A84C]" data-id="element-108" />
              </div>
              <p className="font-body text-gray-300 text-sm sm:text-base leading-relaxed pt-1" data-id="element-109">
                Buscas perder grasa y ganar energía sin hacer "cardio eterno"
              </p>
            </div>
          </div>

          {/* Card 5 */}
          <div className="bg-[#1a1a1a] border border-[#2a2a2a] border-l-4 border-l-[#C9A84C] p-6 group hover:bg-[#1f1f1f] transition-colors duration-200" data-id="element-110">
            <div className="flex items-start gap-4" data-id="element-111">
              <div className="flex-shrink-0 w-10 h-10 bg-[#C9A84C]/10 rounded flex items-center justify-center" data-id="element-112">
                <TrophyIcon size={20} className="text-[#C9A84C]" data-id="element-113" />
              </div>
              <p className="font-body text-gray-300 text-sm sm:text-base leading-relaxed pt-1" data-id="element-114">
                Te interesa competir o simplemente entrenar como un atleta
              </p>
            </div>
          </div>

          {/* Card 6 */}
          <div className="bg-[#1a1a1a] border border-[#2a2a2a] border-l-4 border-l-[#C9A84C] p-6 group hover:bg-[#1f1f1f] transition-colors duration-200" data-id="element-115">
            <div className="flex items-start gap-4" data-id="element-116">
              <div className="flex-shrink-0 w-10 h-10 bg-[#C9A84C]/10 rounded flex items-center justify-center" data-id="element-117">
                <ClipboardListIcon size={20} className="text-[#C9A84C]" data-id="element-118" />
              </div>
              <p className="font-body text-gray-300 text-sm sm:text-base leading-relaxed pt-1" data-id="element-119">
                Quieres un plan (entrenamiento + nutrición) en vez de improvisar
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}